import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'

import { projectContext, loadingContext, unfolder, urlValue, onImportExcelAsync, downloadFile } from '../lib/index.js'
import SideBar from '../components/SideBar.jsx'
import TitleBar from "../components/TitleBar.jsx";
import CheckBox2 from '../components/CheckBox2.js'
import Loading from '../components/Loading.js'
import BoxInfo from '../components/common/BoxInfo.js'
import { Tooltip } from 'react-tooltip'
import Button from '../components/provider/button/button.jsx'
import '../styles/cost_center.css'

export default function CostCenter() {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [records, setRecords] = useState({list: []})
  const [isModalOpen, setIsModalOpen] = useState({ delete: false, code: false })
  const [sidePanel, setSidePanel] = useState('detail')
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const [date, setDate] = useState('');

  useEffect(() => {
    const currentDate = new Date()
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript van de 0 a 11
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}` //`${currentDate.getDate().toString().padStart(2, '0')}/${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getFullYear()}`;
    setDate(formattedDate)
  }, [sidePanel])

  useEffect(() => {
    getBatchByUserAuth();
  }, [date])

  const getBatchByUserAuth = ()=>{
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      setLoading(false)
      setRecords({list: []})

      if (date != ''){
        const dateSelect = new Date(date);
        
        // Obtener el primer día del mes
        const firstDay = new Date(dateSelect.getFullYear(), dateSelect.getMonth(), 1);
        const formattedFirstDay = firstDay.toISOString().split('T')[0];

        // Obtener el último día del mes (día 0 del siguiente mes)
        const lastDay = new Date(dateSelect.getFullYear(), dateSelect.getMonth() + 1, 0);
        const formattedLastDay = lastDay.toISOString().split('T')[0];

        axios({
          method: 'get',
          url: `${urlValue}/studio/cost_center/batch/by/user/${id}`,
          headers: {
              user: id,
              'access-token': token,
              dateInitial: formattedFirstDay,
              dateEnd: formattedLastDay
          },
        })
        .then(function (response) {
            setRecords({list: response.data.data})
            setLoading(false)
        })
        .catch(function (error) {
            console.log(error)
            setLoading(false)
        })
      }
  }

  return (
    <div>
      <section className="container-answers general-container" id="container-adj">
        {/*<SideBar active={'Answers'} />*/}
        <div className="container">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="container-info">
            <div className="header con_header mt-1 ml-2">
              <div className="title"> 
                <div className="intents">
                  <div className="project-name-container">
                    <strong><h2 className='billing_title' style={{paddingLeft: 0}}>Cost Center</h2></strong>
                  </div>
                </div>
              </div>
            </div>

            <div className="body left-c" id="answer-all">
              <div className="d-flex flex-row justify-space-between align-items-center">
                <div className='d-flex flex-row align-items-center justify-space-between w-100'>
                    <div className="home-search ml-3 bg-white d-flex flex-row align-items-center justify-space-between"
                        style={{ borderRadius: 20, backgroundColor: 'white', width: 215, border: '1px solid gray' }}>
                        <input
                            type="text"
                            placeholder="Campaign Search"
                            onChange={event => {
                            setSearch(event.target.value)
                            }}
                            style={{ border: 'none', fontSize: 16, marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                            className="p-2 home-search"
                        />
                        <div className="p-1 mr-3 mt-1">
                            <img src="/icons/search.svg" style={{ width: 16 }} alt="magnifying" />
                        </div>
                    </div>

                    <div className="home-search ml-1 mr-1 bg-white d-flex flex-row align-items-center justify-space-between"
                        style={{ borderRadius: 20, backgroundColor: 'white', width: 215, border: '1px solid gray' }}>
                        <input
                            type="text"
                            placeholder="Sub-campaign Search"
                            onChange={event => {
                            setSearch(event.target.value)
                            }}
                            style={{ border: 'none', fontSize: 16, marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                            className="p-2 home-search"
                        />
                        <div className="p-1 mr-3 mt-1">
                            <img src="/icons/search.svg" style={{ width: 16 }} alt="magnifying" />
                        </div>
                    </div>

                    <div className="home-search ml-1 mr-1 bg-white d-flex flex-row align-items-center justify-space-between"
                        style={{ borderRadius: 20, backgroundColor: 'white', width: 215, border: '1px solid gray' }}>
                        <input
                            type="text"
                            placeholder="Amount Search"
                            onChange={event => {
                            setSearch(event.target.value)
                            }}
                            style={{ border: 'none', fontSize: 16, marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                            className="p-2 home-search"
                        />
                        <div className="p-1 mr-3 mt-1">
                            <img src="/icons/search.svg" style={{ width: 16 }} alt="magnifying" />
                        </div>
                    </div>

                    <div className="ml-1 mr-1 d-flex flex-row align-items-center justify-space-between"
                        style={{ borderRadius: 20 }}>
                        <label htmlFor="month" className='label_month'>Month</label>
                        <input
                            id="month"
                            type="date"
                            placeholder="Select month"
                            value={date}
                            onChange={event => {
                              setDate(event.target.value)
                              setSearch(event.target.value)
                            }}
                            style={{ border: 'none', fontSize: 16, marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                            className="p-2 home-search input-date"
                        />
                    </div>
                </div>
              </div>

                <div className={'w-100 mt-3'}>
                    <table className={'table-cost-center w-100'}>
                        <thead>
                            <tr>
                                <th>Campaign</th>
                                <th>Subcampaign</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            records?.list?.map((el, index) => {
                                return <tr>
                                    <td>{el.campaign}</td>
                                    <td>{el.sub_campaign}</td>
                                    <td>{Number(el.costs + el.costs_azure).toFixed(2).toLocaleString()}</td>
                                </tr>
                            })
                        }
                        </tbody>
                    </table>
                </div>
              
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
